var Domain = ["payments.pabbly.com", "localhost:5000", "mg-mail4.com", "testpayments.pabbly.com"];

export default Domain;